<template>
  <div class="content">
    <!-- 银行卡列表区域 -->
    <div data-v-3cb7ae5b="" class="cardsDetail">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in cardLis" :key="index">
          <div data-v-3cb7ae5b="" class="card bank-card">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <img data-v-3cb7ae5b="" :src="item.ico" alt="银行图标" class="bankIcon" />
                <span data-v-3cb7ae5b="" class="bankName">{{ item.bank }}</span>
              </p>
            </div>
            <p data-v-3cb7ae5b="" class="cardOwner">{{ item.bank_owner }}</p>
            <p data-v-3cb7ae5b="" class="cardNum">{{ item.bank_no }}</p>
            <p data-v-3cb7ae5b="" class="unbind-btn" @click="delShow(item)">解绑</p>
          </div>
        </li>
      </ul>

      <!-- 添加银行卡按钮 -->
      <div data-v-3cb7ae5b="" class="add-method" v-if="cardLis.length < 5" @click="$parent.goNav('/addBankCard')">
        <div data-v-3cb7ae5b="" class="add-btn">
          <div data-v-3cb7ae5b="" class="add-icon"><i class="fas fa-plus"></i></div>
          <span data-v-3cb7ae5b="" class="add-title">添加银行卡</span>
        </div>
      </div>
    </div>

    <!-- USDT钱包列表区域 -->
    <div data-v-3cb7ae5b="" class="cardsDetail usdt-section">
      <ul data-v-3cb7ae5b="" class="cards">
        <li data-v-3cb7ae5b="" v-for="(item, index) in usdssLis" :key="index">
          <div data-v-3cb7ae5b="" class="card usdt-card">
            <div data-v-3cb7ae5b="" class="bank">
              <p data-v-3cb7ae5b="" class="iconName">
                <span data-v-3cb7ae5b="" class="bankName">{{ item.bank }}（{{ item.bank_owner }}）</span>
              </p>
            </div>
            <p data-v-3cb7ae5b="" class="cardNum usdt-address">{{ item.bank_no }}</p>
            <p data-v-3cb7ae5b="" class="unbind-btn" @click="delShow(item)">解绑</p>
          </div>
        </li>
      </ul>

      <!-- 添加USDT按钮 -->
      <div data-v-3cb7ae5b="" class="add-method" v-if="usdssLis.length < 5" @click="$parent.goNav('/addUsdtCard')">
        <div data-v-3cb7ae5b="" class="add-btn">
          <div data-v-3cb7ae5b="" class="add-icon"><i class="fas fa-plus"></i></div>
          <span data-v-3cb7ae5b="" class="add-title">添加USDT</span>
        </div>
      </div>
    </div>

    <!-- 解绑确认弹窗 -->
    <div data-v-710c460e="" data-v-0dc57850="" class="popup-background" v-if="delBox.id" @touchmove.prevent>
      <div data-v-0dc57850="" data-v-710c460e="" class="safety-popup">
        <div data-v-0dc57850="" data-v-710c460e="" class="popup">
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-head">
            <span class="pop-title">操作确认</span>
            <a data-v-0dc57850="" data-v-710c460e="" @click="closeDel" class="pop-close"><i class="fas fa-times"></i></a>
          </div>
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-content">
            <p data-v-0dc57850="" data-v-710c460e="">您确定要删除</p>
            <p data-v-0dc57850="" data-v-710c460e="" class="del-target">
              {{ delBox.bank === 'USDT' ? delBox.bank_no : delBox.bank_no }}
              <span v-if="delBox.bank !== 'USDT'">-{{ delBox.bank_owner }}</span>
            </p>
            <p data-v-0dc57850="" data-v-710c460e="">吗？</p>
            <button data-v-0dc57850="" data-v-710c460e="" @click="isDelOk()" class="delete-btn">立即删除</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bankCard',
  data() {
    return {
      usdssLis: [],
      cardLis: [],
      baseURL: '',
      delBox: {},
    };
  },
  created() {
    this.baseURL = sessionStorage.getItem('baseURL') || '';
    this.getUsdssList();
    this.getcard();

  },
  methods: {
    // 获取USDT列表
    getUsdssList() {
      this.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code === 200) {
          this.usdssLis = res.data;
        }
      });
    },
    // 获取银行卡列表
    getcard() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        this.cardLis = res.data;
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    // 显示解绑弹窗
    delShow(item) {
      this.delBox = { ...item };
    },
    // 关闭解绑弹窗
    closeDel() {
      this.delBox = {};
    },
    // 确认解绑
    isDelOk() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/delcard', { id: this.delBox.id }).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        this.$parent.showTost(1, '解绑成功');
        this.delBox = {};
        this.getcard();
        this.getUsdssList();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 基础变量
$white: #ffffff;
$light-gray: #f9fafb;
$border-gray: #e5e7eb;
$accent: #165DFF;
$usdt-color: #23a2a2;
$bank-color: #722ED1;
$error-red: #FF4D4F;
$text-dark: #1f2937;
$text-gray: #4b5563;
$text-light-gray: #9ca3af;
$transition: all 0.3s ease;
$radius: 8px;

// 页面容器
.content {
  width: 100%;
  min-height: calc(100vh - 110px);
  background: $light-gray;
  padding: 16px;
  box-sizing: border-box;
}

// 列表区域容器
.cardsDetail {
  background: $white;
  border-radius: $radius;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  // USDT区域与银行卡区域间距
  &.usdt-section {
    margin-bottom: 0;
  }
}

// 卡片列表
.cards {
  list-style: none;
  padding: 0;
  margin: 0 0 18px 0;
}

// 卡片列表项 - 确保所有卡片大小一致
.cards li {
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
}

// 卡片容器（统一大小统一）
.card {
  position: relative;
  height: 100px;
  border-radius: $radius;
  padding: 16px;
  transition: $transition;
  color: $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
}

// 银行卡特殊样式
.bank-card {
  background: linear-gradient(135deg, $bank-color 0%, #5319b7 100%);
  box-shadow: 0 4px 12px rgba(114, 46, 209, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(114, 46, 209, 0.3);
  }
}

// USDT卡片特殊样式
.usdt-card {
  background: linear-gradient(135deg, $usdt-color 0%, #1a8c8c 100%);
  box-shadow: 0 4px 12px rgba(35, 162, 162, 0.2);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(35, 162, 162, 0.3);
  }
}

// 银行/USDT名称区域
.bank {
  margin-bottom: 8px;
}

.iconName {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

// 银行图标
.bankIcon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 2px;
}

// 银行/USDT名称
.bankName {
  font-size: 15px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

// 银行卡持卡人
.cardOwner {
  font-size: 13px;
  margin: 0 0 4px 0;
  padding: 0;
  opacity: 0.9;
}

// 卡号/USDT地址（全部显示）
.cardNum {
  font-size: 14px;
  margin: 0;
  padding: 0;
  letter-spacing: 0.5px;
  font-family: 'Courier New', monospace;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  // USDT地址样式
  &.usdt-address {
    letter-spacing: normal;
  }
}

// 解绑按钮
.unbind-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  margin: 0;
  padding: 0;
  transition: $transition;
  background-color: rgba(255, 255, 255, 0.15);
  padding: 3px 8px;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }
}

// 添加按钮容器
.add-method {
  width: 100%;
}

// 添加按钮
.add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  background: $light-gray;
  border: 1px dashed $border-gray;
  border-radius: $radius;
  cursor: pointer;
  transition: $transition;

  &:hover {
    background: rgba(22, 93, 255, 0.05);
    border-color: $accent;
  }
}

// 添加按钮图标
.add-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: $white;
  border: 1px solid $border-gray;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: $transition;

  .add-btn:hover & {
    background: $accent;
    border-color: $accent;
    color: $white;
  }
}

// 添加按钮文字
.add-title {
  font-size: 14px;
  color: $text-gray;
  transition: $transition;

  .add-btn:hover & {
    color: $accent;
    font-weight: 500;
  }
}

// 弹窗背景
.popup-background {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 弹窗容器
.safety-popup {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}

// 弹窗主体
.popup {
  background: $white;
  border-radius: $radius;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

// 弹窗头部
.pop-head {
  position: relative;
  height: 48px;
  line-height: 48px;
  padding: 0 18px;
  border-bottom: 1px solid $border-gray;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// 弹窗标题
.pop-title {
  font-size: 16px;
  color: $text-dark;
  font-weight: 500;
}

// 弹窗关闭按钮
.pop-close {
  color: $text-light-gray;
  font-size: 18px;
  cursor: pointer;
  transition: $transition;

  &:hover {
    color: $error-red;
  }
}

// 弹窗内容区
.pop-content {
  padding: 24px 18px;
  text-align: center;
}

.pop-content p {
  font-size: 14px;
  color: $text-gray;
  margin: 0 0 8px 0;
  padding: 0;
}

// 待删除目标文本（卡号/地址）
.del-target {
  color: $accent;
  font-weight: 500;
  margin: 10px 0;
  padding: 8px;
  background: $light-gray;
  border-radius: 4px;
  word-break: break-all;
  font-family: 'Courier New', monospace;
}

// 确认删除按钮
.delete-btn {
  width: 100%;
  height: 44px;
  background: $error-red;
  color: $white;
  border: none;
  border-radius: $radius;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: $transition;

  &:hover {
    background: #d92d20;
    transform: translateY(-2px);
  }
}

// 移动端适配
@media (max-width: 375px) {
  .content {
    padding: 12px;
  }

  .cardsDetail {
    padding: 14px;
  }

  .card {
    height: 90px;
    padding: 12px;
  }
  
  .cardNum {
    font-size: 13px;
  }

  .unbind-btn {
    top: 12px;
    right: 12px;
    font-size: 12px;
  }

  .add-btn {
    height: 40px;
  }

  .popup {
    width: 100%;
  }

  .pop-content {
    padding: 20px 14px;
  }

  .delete-btn {
    height: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bankCard.vue